var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoWebsite01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 40.8 40.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40.8,
    height: 40.8,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0,
    width: 40.8,
    height: 40.8,
    rx: 8,
    ry: 8,
    fill: "#f2642a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.9442,28.3705c0,.526-.429.955-.955.955H9.9452c-.526,0-.954-.429-.954-.955v-15.941c0-.526.428-.955.954-.955h22.044c.526,0,.955.429.955.955v15.941Zm-.955-17.869H9.9452c-1.063,0-1.928.865-1.928,1.928v15.941c0,1.063.865,1.928,1.928,1.928h22.044c1.063,0,1.928-.865,1.928-1.928v-15.941c0-1.063-.865-1.928-1.928-1.928",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.015,14.05H10.028c-.269,0-.487.218-.487.487,0,.268.218.486.487.486h21.987c.269,0,.487-.218.487-.486,0-.269-.218-.487-.487-.487",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.3814,13.2458c.264,0,.479-.214.479-.479,0-.264-.215-.479-.479-.479s-.479.215-.479.479c0,.265.215.479.479.479",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.5886,13.2458c.264,0,.479-.214.479-.479,0-.264-.215-.479-.479-.479s-.479.215-.479.479c0,.265.215.479.479.479",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.5664,13.2458c.264,0,.479-.214.479-.479,0-.264-.215-.479-.479-.479s-.479.215-.479.479c0,.265.215.479.479.479",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.0858,18.9066h-14.237c-.269,0-.486.218-.486.487,0,.268.217.486.486.486h14.237c.269,0,.487-.218.487-.486,0-.269-.218-.487-.487-.487",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.2251,22.4821c0-.269-.218-.487-.487-.487h-9.542c-.269,0-.486.218-.486.487s.217.487.486.487h9.542c.269,0,.487-.218.487-.487",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWebsite01);
export default __webpack_public_path__ + "static/media/ico-website-01.02dcbd7aa338a284b66184dfca8fc387.svg";
export { ForwardRef as ReactComponent };